var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
var React = require('react');
var	ReactDOM = require('react-dom');
var createReactClass = require('create-react-class');
var PostListItem = require('./postListItem.jsx');

var PostListPartial = createReactClass({
	componentDidMount: function() {
		$(ReactDOM.findDOMNode(this)).masonry({
			itemSelector: '.column'
		});
	},

	componentDidUpdate: function(prevProps){
		if(this.props.categorySlug !== prevProps.categorySlug
            || this.props.pageNum !== prevProps.pageNum){

			$(ReactDOM.findDOMNode(this))
				.masonry('destroy')
				.masonry({
					itemSelector: '.column'
				});
		}
		// $(ReactDOM.findDOMNode(this)).masonry('layout');
	},

	render: function () {

        var postListItemNodes = this.props.postContainers.map(function(postContainer, index){
            return <PostListItem postContainer={postContainer} key={index} setPost={this.props.setPost} />;
        }.bind(this));

        return (
            <div className={'row medium-up-' + (this.props.size || 3)}>
                {postListItemNodes}
            </div>
        );
    }
});

module.exports = PostListPartial;



// WEBPACK FOOTER //
// ./src/common/routes/posts/components/layout/postListPartial.jsx